import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { colors } from '../../../../../../../colorVars';
import { MultiSwitch } from '../../../../../../atomic/buttons/multiSwitch/MultiSwitch';
import { ChartDataList } from '../../../../../../atomic/inputs/datalist/chartDataList/ChartDataList';
import style from './AlertChartHeader.module.css';
export const candleNumberArray = [5, 10, 20, 30, 40, 50];

function AlertChartHeader({
  setters,
  symbol,
  numberOfCandles,
  timeUnit,
  candleDuration,
  showCandleNumbers,
}) {
  const timeUnitArray = [
    { value: 'MINUTES', label: 'Min.' },
    { value: 'DAYS', label: 'Day' },
    { value: 'WEEKS', label: 'Week' },
    { value: 'MONTHS', label: 'Month' },
  ];
  const candleDurationArray = [1, 3, 5, 10, 15, 20, 30, 60, 120];

  const {
    setSymbol,
    setNumberOfCandles,
    setTimeUnit,
    setCandleDuration,
    setShowCandleNumbers,
  } = setters;

  const [symbolDisplay, setSymbolDisplay] = useState(symbol);

  useEffect(() => {
    if (symbol) setSymbolDisplay(symbol);
  }, [symbol]);

  return (
    <div
      className={`${style.container} noDragTag`}
      style={{ backgroundColor: colors.black }}
    >
      <div className={style.inputWrapper}>
        <input
          className={style.input}
          type="text"
          value={symbolDisplay}
          onChange={({ target }) => setSymbolDisplay(target.value)}
          onBlur={() => setSymbol(symbolDisplay)}
        />
        <img
          className={style.searchIcon}
          src="https://res.cloudinary.com/glasswavs/image/upload/v1632778351/outline_search_white_24dp_vculzf.png"
          alt=""
          width="15px"
        />{' '}
      </div>

      <select
        className={style.select}
        name="numberOfCandles"
        id="numberOfCandles"
        value={numberOfCandles}
        onChange={({ target }) => setNumberOfCandles(Number(target.value))}
      >
        <option style={{ display: 'none' }} value="default">
          cust
        </option>
        {candleNumberArray.map((value) => (
          <option value={value} key={value}>
            {value + 'x'}
          </option>
        ))}
      </select>

      <ChartDataList
        backgroundColor={colors.black}
        id="candleDuration"
        dataList={candleDurationArray}
        controlledValue={candleDuration}
        onBlurFn={(value) => setCandleDuration(value)}
        dataListMapFn={(value) => (
          <option key={value} value={value}>
            {value}
          </option>
        )}
      >
        ...
      </ChartDataList>
      <select
        className={style.select}
        name="timeUnit"
        id="timeUnit"
        value={timeUnit}
        onChange={({ target }) => setTimeUnit(target.value)}
      >
        {timeUnitArray.map(({ value, label }) => (
          <option value={value} key={value}>
            {label}
          </option>
        ))}
      </select>
      <MultiSwitch
        margin="0 0 0 3px"
        labels={['1-2-3', 'Off']}
        values={[true, false]}
        setValue={setShowCandleNumbers}
        controlledValue={showCandleNumbers}
      />
    </div>
  );
}

AlertChartHeader.propTypes = {
  brokerage: PropTypes.any,
  candleDuration: PropTypes.any,
  dataSource: PropTypes.any,
  headerData: PropTypes.shape({
    ask: PropTypes.number,
    bid: PropTypes.number,
    last: PropTypes.number,
    volume: PropTypes.number,
  }),
  numberOfCandles: PropTypes.any,
  setters: PropTypes.shape({
    setBrokerage: PropTypes.func,
    setCandleDuration: PropTypes.func,
    setDataSource: PropTypes.func,
    setNumberOfCandles: PropTypes.func,
    setShowCandleNumbers: PropTypes.any,
    setSymbol: PropTypes.func,
    setTimeUnit: PropTypes.func,
  }),
  showCandleNumbers: PropTypes.any,
  symbol: PropTypes.any,
  timeUnit: PropTypes.any,
  type: PropTypes.string.isRequired,
  values: PropTypes.shape({
    brokerage: PropTypes.string,
    candleDuration: PropTypes.any,
    dataSource: PropTypes.string,
    numberOfCandles: PropTypes.any,
    showCandleNumbers: PropTypes.any,
    symbol: PropTypes.any,
    timeUnit: PropTypes.any,
  }),
};

export default AlertChartHeader;
